// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host([lines=none]) ion-item {
  --border-width: 0;
}

ion-item {
  --box-shadow: 0px 1px 5px rgba(0, 0, 0, 0.13) !important;
  --border-radius: 16px !important;
  margin: 3px;
  margin-bottom: 3px !important;
  margin-top: 2px !important;
  cursor: pointer;
  --padding-end: 8px;
}
ion-item.event-item {
  margin-top: var(--boxx-item-margin-top, 16px);
  margin-bottom: var(--boxx-item-margin-bottom, 16px);
  padding: var(--boxx-item-padding, 0);
  border-radius: var(--boxx-item-border-radius, 8px);
}
ion-item:last-child {
  margin-bottom: 0;
}
ion-item.selected {
  --background: var(--boxx-item-selected-bg, lightblue);
}
ion-item ion-label {
  margin-bottom: 8px;
  margin-top: 8px;
}

.event-calendar {
  margin-top: var(--boxx-calendar-margin-top, 16px);
  margin-bottom: var(--boxx-calendar-margin-bottom, 16px);
  margin-left: var(--boxx-calendar-margin-left, 0px);
  margin-right: var(--boxx-calendar-margin-right, 24px);
  text-align: var(--boxx-calendar-text-align, center);
  text-transform: var(--boxx-calendar-text-transform, uppercase);
  color: var(--boxx-calendar-color, var(--ion-text-color));
  line-height: var(--boxx-calendar-line-height, 1);
  background: var(--boxx-calendar-background, transparent);
}
.event-calendar .day-of-week {
  text-transform: capitalize;
  font-size: 15px;
  font-weight: 500;
  margin-bottom: 8px;
}
.event-calendar .day-of-month,
.event-calendar .month-name {
  font-size: 21px;
  font-weight: 600;
}
.event-calendar .two-months-name {
  font-size: 9px;
  font-weight: 600;
}
.event-calendar .day-of-month {
  margin-bottom: 4px;
}

ion-label {
  height: 100%;
  margin-top: 0px;
  margin-bottom: 0px;
  padding-top: 12px;
}
ion-label div {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
ion-label .event-title {
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 2px;
}
ion-label .event-place {
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 4px;
  color: #586677 !important;
}
ion-label .event-place ion-icon {
  margin-top: 0;
  margin-bottom: 0;
}
ion-label .event-date {
  display: flex;
  align-items: center;
  font-size: 16px;
  font-weight: 500;
  color: var(--ion-color-primary);
}
ion-label .event-date ion-icon {
  margin-top: auto;
  margin-bottom: auto;
  margin-right: 4px;
}

.attendee-avatar-container {
  display: flex;
  align-items: flex-end;
  white-space: initial;
  font-size: small;
}
.attendee-avatar-container ion-avatar {
  min-width: 24px;
  width: 24px;
  height: 24px;
  font-size: 12px;
  font-weight: 500;
  margin-right: 6px;
  padding: 0;
  border: 0;
}
.attendee-avatar-container ion-avatar div {
  background: var(--ion-color-primary) !important;
  color: #ffffff;
}

.detail-icon ::ng-deep ion-icon {
  color: var(--boxx-detail-icon-color, var(--ion-text-color));
  width: var(--boxx-detail-icon-width, 20px);
}

.item-detail-icon ion-icon {
  color: var(--ion-color-tertiary);
}`, "",{"version":3,"sources":["webpack://./src/modules/@boxx/events-core/lib/components/appointment-item/appointment-item.component.scss"],"names":[],"mappings":"AACE;EACE,iBAAA;AAAJ;;AAIA;EAEE,wDAAA;EAEA,gCAAA;EACA,WAAA;EACA,6BAAA;EACA,0BAAA;EACA,eAAA;EACA,kBAAA;AAHF;AAKE;EACE,6CAAA;EACA,mDAAA;EACA,oCAAA;EACA,kDAAA;AAHJ;AAME;EACE,gBAAA;AAJJ;AAOE;EACE,qDAAA;AALJ;AAQE;EACE,kBAAA;EACA,eAAA;AANJ;;AAUA;EACE,iDAAA;EACA,uDAAA;EACA,kDAAA;EACA,qDAAA;EACA,mDAAA;EACA,8DAAA;EACA,wDAAA;EACA,gDAAA;EACA,wDAAA;AAPF;AASE;EACE,0BAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AAPJ;AASE;;EAEE,eAAA;EACA,gBAAA;AAPJ;AAUE;EACE,cAAA;EACA,gBAAA;AARJ;AAWE;EACE,kBAAA;AATJ;;AAaA;EACE,YAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;AAVF;AAYE;EACE,uBAAA;EACA,mBAAA;EACA,gBAAA;AAVJ;AAYE;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;AAVJ;AAYE;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;AAVJ;AAYI;EACE,aAAA;EACA,gBAAA;AAVN;AAaE;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,+BAAA;AAXJ;AAYI;EACE,gBAAA;EACA,mBAAA;EACA,iBAAA;AAVN;;AAeA;EACE,aAAA;EACA,qBAAA;EACA,oBAAA;EACA,gBAAA;AAZF;AAcE;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,UAAA;EACA,SAAA;AAZJ;AAcI;EACE,+CAAA;EACA,cAAA;AAZN;;AAkBE;EACE,2DAAA;EACA,0CAAA;AAfJ;;AAmBA;EAGE,gCAAA;AAlBF","sourcesContent":[":host([lines=\"none\"]) {\n  ion-item {\n    --border-width: 0;\n  }\n}\n\nion-item {\n\n  --box-shadow: 0px 1px 5px rgba(0, 0, 0, 0.13) !important;\n  //--border-radius: 7.99581px !important;\n  --border-radius: 16px !important;\n  margin: 3px;\n  margin-bottom: 3px !important;\n  margin-top: 2px !important;\n  cursor: pointer;\n  --padding-end: 8px;\n\n  &.event-item {\n    margin-top: var(--boxx-item-margin-top, 16px);\n    margin-bottom: var(--boxx-item-margin-bottom, 16px);\n    padding: var(--boxx-item-padding, 0);\n    border-radius: var(--boxx-item-border-radius, 8px);\n  }\n\n  &:last-child {\n    margin-bottom: 0;\n  }\n\n  &.selected {\n    --background: var(--boxx-item-selected-bg, lightblue);\n  }\n\n  ion-label{\n    margin-bottom: 8px;\n    margin-top: 8px;\n  }\n}\n\n.event-calendar {\n  margin-top: var(--boxx-calendar-margin-top, 16px);\n  margin-bottom: var(--boxx-calendar-margin-bottom, 16px);\n  margin-left: var(--boxx-calendar-margin-left, 0px);\n  margin-right: var(--boxx-calendar-margin-right, 24px);\n  text-align: var(--boxx-calendar-text-align, center);\n  text-transform: var(--boxx-calendar-text-transform, uppercase);\n  color: var(--boxx-calendar-color, var(--ion-text-color));\n  line-height: var(--boxx-calendar-line-height, 1);\n  background: var(--boxx-calendar-background, transparent);\n\n  .day-of-week {\n    text-transform: capitalize;\n    font-size: 15px;\n    font-weight: 500;\n    margin-bottom: 8px;\n  }\n  .day-of-month,\n  .month-name {\n    font-size: 21px;\n    font-weight: 600;\n  }\n\n  .two-months-name {\n    font-size: 9px;\n    font-weight: 600;\n  }\n\n  .day-of-month {\n    margin-bottom: 4px;\n  }\n}\n\nion-label {\n  height: 100%;\n  margin-top: 0px;\n  margin-bottom: 0px;\n  padding-top: 12px; // total = 16\n\n  div {\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    overflow: hidden;\n  }\n  .event-title {\n    font-size: 14px;\n    font-weight: 600;\n    margin-bottom: 2px;\n  }\n  .event-place {\n    font-size: 14px;\n    font-weight: 500;\n    margin-bottom: 4px;\n    color: #586677 !important;\n\n    ion-icon {\n      margin-top: 0;\n      margin-bottom: 0;\n    }\n  }\n  .event-date {\n    display: flex;\n    align-items: center;\n    font-size: 16px;\n    font-weight: 500;\n    color: var(--ion-color-primary);\n    ion-icon {\n      margin-top: auto;\n      margin-bottom: auto;\n      margin-right: 4px;\n    }\n  }\n}\n\n.attendee-avatar-container {\n  display: flex;\n  align-items: flex-end;\n  white-space: initial;\n  font-size: small;\n\n  ion-avatar {\n    min-width: 24px;\n    width: 24px;\n    height: 24px;\n    font-size: 12px;\n    font-weight: 500;\n    margin-right: 6px;\n    padding: 0;\n    border: 0;\n\n    div{\n      background: var(--ion-color-primary) !important;\n      color: #ffffff;\n    }\n  }\n}\n\n.detail-icon {\n  ::ng-deep ion-icon {\n    color: var(--boxx-detail-icon-color, var(--ion-text-color));\n    width: var(--boxx-detail-icon-width, 20px);\n  }\n}\n\n.item-detail-icon ion-icon {\n  // width: 28px;\n  // height: 28px;\n  color: var(--ion-color-tertiary);\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
